import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ConfirmationModal from "../commonModals/ConfirmationModal";
import helper from "../../utils/helper";
import ROUTES from "../../constant/routes";
import storage from "../../utils/storage";
import { ADMIN_KEY, ARTIST_KEY } from "../../constant/commonConstants";


import { loginUserByAdmin } from "../../services/user";
import toast from "../../utils/toastsMessage";
import AdminSettings from "../../container/admin/adminSettings/AdminSettings";
import logo from "../../assets/images/footer-logo.png";
import Avatar from "../../assets/images/avatar.png";
import { authIntialState, authStore } from "../../store/authStore";


import "./Header.scss";
import SVGFiles from "../SVGFiles";


const Header: React.FC = () => {

  const navigate = useNavigate();
  const adminTokenData = storage.get(ADMIN_KEY);
  const artistTokenData = storage.get(ARTIST_KEY);
  const { t: translation } = useTranslation();
  const {state:authUser,update:updateAuthUser} = authStore((state) => state);


  const encryptId = helper.getEncryptId(authUser.id as number);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleLogOut = async () => {
    updateAuthUser(authIntialState)
    storage.removeAll();
    (adminTokenData || artistTokenData) ? navigate(ROUTES.ADMIN_LOGIN) : navigate(ROUTES.LOGIN);
  };

  const handleAdminLogin = async () => {
    // REMOVE DATA IF EXIST
    updateAuthUser(authIntialState);
    if(!adminTokenData && !artistTokenData) {
      toast.error(translation("token-expired"));
      return;
    }
    const {data:response} = await loginUserByAdmin({ token: adminTokenData ? adminTokenData : artistTokenData });
    storage.removeAll();

    if (response && response.success && response.data) {
      const userData = response?.data?.userInfo;
      const address = JSON.parse(response?.data?.userInfo?.address);
      updateAuthUser({...userData, address, isLoggedIn: true});
      storage.set("__RTA__", userData?.token);
      storage.set("authData", JSON.stringify({ ...userData, address, isLoggedIn: true }));
      navigate(ROUTES.USER_LIST);
    }
  };

  return (
    <div className="header">
      <AdminSettings/>
      <div className="container">
        <nav className="navbar navbar-expand-md header-bg">
          <Link className="navbar-brand" to={ROUTES.HOME}>
            <div>
              <img className="logo" src={logo} alt="" />
            </div>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsibleNavbar"
          >
            
            <SVGFiles name="navbarMenuIcon" />
          </button>

          <div
            className="collapse navbar-collapse align-items-center justify-content-end"
            id="collapsibleNavbar"
          >
            <ul className="navbar-nav me-2">
              <li className="nav-item bd-right">
                <Link className="nav-link" to={ROUTES.PLANS}>
                  {translation("header_pricing")}
                </Link>
              </li>
              <li className="nav-item bd-right">
                <Link className="nav-link" to={ROUTES.CONTACT}>
                  {translation("contact_us")}
                </Link>
              </li>
            </ul>
            {(adminTokenData || artistTokenData) && (
              <button
                className="btn theme-button primary-btn me-4"
                type="button"
                onClick={() => handleAdminLogin()}
              >
                {translation(artistTokenData ? "back_to_artist" : "back_to_admin")}
              </button>
            )}

            <button
              className="btn theme-button primary-btn me-4"
              type="button"
              onClick={() => {
                if (authUser.isLoggedIn) {
                  if (authUser.address?.address_line_1) {
                    navigate(ROUTES.UPLOAD_ARTWORK);
                  } else {
                    toast.error(translation("complete_profile_first"));
                  }
                } else {
                  navigate(ROUTES.LOGIN);
                }
              }}
            >
              {translation("header_upload_art")}
            </button>
            {!authUser.isLoggedIn ? (
              <button
                type="button"
                className=" theme-button black-btn-outline me-3"
                onClick={() => navigate(ROUTES.LOGIN)}
              >
                {translation("login")}
              </button>
            ) : (
              <div className="form-group mb-0">
                <div className="header-profile">
                  {authUser.image ? (
                    <div className="user-box">
                      <img
                       src={helper.profileImageHandler(authUser.image)}
                       onError={(ev) => {
                        (ev.target as HTMLInputElement).src =Avatar
                      }}
                      alt=""
                      loading="lazy"
                      className="default-image fix-img-sm border-theme  font-sm"
                      />
                      {authUser.address === null ? (
                        <span>
                           <SVGFiles name="invalidProfileIcon" />
                        </span>
                      ) : null}
                    </div>
                  ) : (
                    <div className="user-box">
                      <div className="default-image fix-img-sm border-theme  font-sm">
                        {helper.capitalize(
                          authUser.first_name?.charAt(0) as string
                        )}
                      </div>
                      {authUser.address === null ? (
                        <span>
                          <SVGFiles name="invalidProfileIcon" />
                        </span>
                      ) : null}
                    </div>
                  )}
                  <ul
                    className=" user-dropdown"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <Link className="dropdown-item" to={ROUTES.PROFILE}>
                          <SVGFiles name="myprofileIcon" />
                        {translation("header_my_profile")}
                        {authUser.address === null ? (
                          <span className="profile-status">
                            <SVGFiles name="profileStatusIcon" />
                          </span>
                        ) : null}
                      </Link>
                    </li>
                    <li>
                      <span
                        className="dropdown-item"
                        onClick={() => {
                          if (authUser.address?.address_line_1) {
                            navigate(
                              authUser.isLoggedIn
                                ? ROUTES.USER_ORDER_LIST.replace(
                                    ":userId",
                                    encryptId
                                  )
                                : ROUTES.LOGIN
                            );
                          } else {
                            toast.error(translation("complete_profile_first"));
                          }
                        }}
                      >
                        <SVGFiles name="myOrdersIcon" />
                        {translation("header_my_orders")}
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setShowConfirmModal(!showConfirmModal)}
                        className="dropdown-item"
                      >
                        <SVGFiles name="logoutIcon" />
                        {translation("dashboard_logout")}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </nav>
      </div>
      {showConfirmModal && (
        <ConfirmationModal
          heading={translation("dashboard_logout")}
          description={translation("logout_modal_description")}
          onClickOkay={() => handleLogOut()}
          onClickCancel={() => setShowConfirmModal(false)}
        />
      )}
    </div>
  );
};

export default Header;
